<template>
  <modal :show.sync="isActiveLocal" size="md" header-classes="bg-primary p-3">
    <h6
      slot="header"
      class="modal-title uppercase text-white font-semibold pt-1"
    >
      Add Number
    </h6>

    <div>
      <div class="">
        <base-input class="w-full" label="Enter Name">
          <b-input placeholder="Type or Enter " />
        </base-input>
      </div>

      <div class="">
        <base-input class="w-full" label="Enter Mobile No">
          <b-input placeholder="Type or Enter " />
        </base-input>
      </div>

      <div class="">
        <base-input class="w-full" label="Email ID">
          <b-input placeholder="Type or Enter " />
        </base-input>
      </div>
    </div>
    <template slot="footer">
      <base-button type="primary">Add </base-button>
      <base-button
        type="secondary"
        class="ml-auto"
        @click="isActiveLocal = false"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>
<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
};
</script>
